import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import { ERetailRevenueSortField, IRetailRevenue, PRetailRevenueFilter } from "src/core/retailRevenue/entities";
import { ActionType, createAction, getType } from "typesafe-actions";
import { EAuthRoles } from "src/core/auth/entities";

/*
 * state
 */
export interface IRetailRevenueState {
  retailRevenues: IRetailRevenue[];
  loading: boolean;
  error: unknown;
  meta: IMeta;
}

const initialState: IRetailRevenueState = {
  retailRevenues: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "retail-revenue/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "retail-revenue/FETCH_SUCCEEDED";
const FETCH_FAILED = "retail-revenue/FETCH_FAILED";
const POLLING_START_REQUESTED = "retail-revenue/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "retail-revenue/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IRetailRevenue[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<unknown>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    role: EAuthRoles;
    filter: PRetailRevenueFilter;
    pagination: IPagination;
    sorts: ISort<ERetailRevenueSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IRetailRevenueState, TActions> = (state = initialState, action) => {
  return produce<IRetailRevenueState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.retailRevenues = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
